/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2022
 */

import { mirror, mult, shift } from '@winds-of-legends/wol-utils'

export default class FaceShape {
  /**
   * Face contour definition
   */
  static faces = {
    0: [[5, 0], [15, 2], [20, 5], [25, 10], [30, 25], [30, 45], [27, 55], [22, 65], [18, 70], [12, 75], [5, 79], [2, 80], [0, 80]],
    1: [[5, 0], [15, 2], [20, 5], [25, 10], [30, 25], [30, 45], [25, 64], [22, 69], [10, 76], [4, 81], [0, 81]],
    2: [[5, 0], [15, 2], [20, 5], [25, 10], [31, 25], [31, 45], [29, 55], [24, 63], [20, 72], [18, 74], [4, 81], [0, 81]],
    3: [[5, 0], [15, 2], [20, 5], [25, 10], [32, 25], [32, 45], [27, 67], [25, 72], [12, 77], [10, 81], [5, 83], [0, 82.5]]
  }

  // static ear0 = [[0, 3], [2, 0], [4, 0], [5, 1], [5, 10], [3, 15], [1, 15], [0, 14]]
  static ear0 = [[0, 5], [16, 0], [20, 0], [20, 1], [5, 12], [3, 17], [1, 17], [-1, 16]]
  /**
   * Ears around face
   */
  static ears = {
    0: FaceShape.ear0.map(shift(30, 20)),
    1: FaceShape.ear0.map(shift(31, 20)),
    2: FaceShape.ear0.map(shift(31, 20)),
    3: FaceShape.ear0.map(shift(32, 20))
  }

  static NECK_BOTTOM = 60
  /**
   * Neck line and shoulder
   */
  static necks = {
    0: [
      // neck to shoulder
      ...[[0, 0], [9, 0], [10, 15], [11, 18], [13, 19], [17, 20], [35, 24]],
      // shoulder to outer elbow
      ...[[42, 25, 'red', 2], [48, 28], [51, 33], [54, 46], [60, 64], [65, 95]]

      //  [0, 0], [10, 0], [11, 15], [12, 18], [15, 20], [50, 25], [50, FaceShape.NECK_BOTTOM], [0, FaceShape.NECK_BOTTOM]
    ],
    1: [[0, 0], [11, 0], [12, 15], [13, 18], [16, 20], [50, 25], [50, FaceShape.NECK_BOTTOM], [0, FaceShape.NECK_BOTTOM]],
    2: [[0, 0], [11, 0], [12, 15], [14, 18], [17, 20], [50, 25], [50, FaceShape.NECK_BOTTOM], [0, FaceShape.NECK_BOTTOM]],
    3: [[0, 0], [14, 0], [15, 15], [16, 18], [19, 20], [50, 25], [50, FaceShape.NECK_BOTTOM], [0, FaceShape.NECK_BOTTOM]]
  }

  /**
   * Right eyebrow
   */
  static eyebrows = {
    0: [[2, 2.5], [2.5, 1.5], [3.5, 1], [5.5, 0.5], [10, 0], [15, 0.5], [20, 2.5], [15, 1.5], [10, 1], [4, 1.5], [2, 2.5]],
    1: [[0, 3], [1, 1], [4, -0.5], [10, -0.5], [18, 0], [21, 1], [23, 3], [18, 1.5], [4, 1.5], [0, 3]],
    2: [[0, 2], [0, 0], [19, 0], [22, 3], [16, 2.5], [4, 2], [0, 2]],
    3: [[0, 0], [20, 0], [21, 3], [0, 4], [0, 0]]
  }

  /**
   * Eyes contour and iris
   */
  static eyes = {
    0: {
      contour: [
        [
          [4, 9], [4, 7.5], [6, 4.5], [9.5, 1], [13, -0.5], [16, -0.75], [19, -0.5], [22.5, 1],
          [25, 3.5], [28.5, 2.5], [25, 3.5],
          [25, 5.5], [29, 5.5], [25, 5.5],
          [24, 7.5], [19, 9.5], [5, 9.5], [4, 9]
        ]
      ],
      back: [
        [
          [4, 9], [4, 7.5], [5.5, 4], [8.5, 0.5], [12.5, -1.5], [16, -2], [19.5, -1.5], [23.5, 0.5],
          [25.5, 3], [28.5, 2.5], [25.5, 3],
          [25.5, 5], [29, 5.5], [25.5, 5.5],
          [24, 7.5], [19, 9.5], [5, 9.5], [4, 9]
        ]
      ],
      iris: [
        ['gray', 14.5, 4.5, 5, 0, 2 * Math.PI],
        ['black', 14.5, 4.5, 2, 0, 2 * Math.PI],
        ['white', 11.5, 2, 1.5, 0, 2 * Math.PI],
        ['white', 17.5, 7, 1, 0, 2 * Math.PI]
      ],
      shift: 29
    },
    1: {
      contour: [
        [
          [4, 7.5], [4, 6], [6, 2.5], [8.5, 0.5], [12, 0], [18, 0], [22, 1], [24, 2],
          [26, 5], [28, 5], [26, 5],
          [24, 7.5], [19, 9], [5, 9], [4, 7.5]
        ]

      ],
      back: [
        [
          [4, 7.5], [4, 5.5], [5.5, 2], [8.5, -0.5], [11.5, -1], [15, -1.5], [18, -1], [22, 0.5], [24, 1.5],
          [26, 4.5], [28, 4.5], [26, 4.5],
          [24, 7.5], [19, 9], [5, 9], [4, 7.5]
        ]
      ],
      iris: [
        ['gray', 14, 4.5, 4.5, 0, 2 * Math.PI],
        ['black', 14, 4.5, 2, 0, 2 * Math.PI],
        ['white', 11.5, 2.5, 1.5, 0, 2 * Math.PI],
        ['white', 17, 6.5, 1, 0, 2 * Math.PI]],
      shift: 28
    },
    2: {
      contour: [
        [[5, 8], [5, 5], [6.5, 2], [10, 0], [18, 0], [23, 1.5], [25, 4], [25, 7]],
        [[5, 8], [5, 5], [7, 2.5], [10, 1], [17, 1], [22, 2], [24, 4], [25, 7]],
        [[7, 9], [20, 9], [23, 8]]
      ],
      iris: [
        ['gray', 14, 5, 4, 0, 2 * Math.PI],
        ['black', 14, 5, 1.75, 0, 2 * Math.PI],
        ['white', 12, 2.5, 1.25, 0, 2 * Math.PI],
        ['white', 16.5, 7, 0.5, 0, 2 * Math.PI]
      ],
      shift: 28
    },
    3: {
      contour: [
        [[6, 6], [6, 5], [7.5, 1.5], [10.5, 0.5], [13, 0], [16, 0], [20.5, 0.5], [22.5, 1.5], [24.5, 5]],
        [[6, 6], [6, 5], [8, 2], [11, 1], [15, 0.5], [19, 1], [22, 2], [24.5, 5]],
        [[8, 7], [19, 7], [23, 6]]
      ],
      iris: [
        ['gray', 14, 4, 3, 0, 2 * Math.PI],
        ['black', 14, 4, 1.5, 0, 2 * Math.PI],
        ['white', 12.5, 2, 1, 0, 2 * Math.PI],
        ['white', 15, 5.5, 0.5, 0, 2 * Math.PI]
      ],
      shift: 28
    }
  }

  /**
   * Noses
   */
  static noses = {
    0: [[0, 1], [-1, 3], [-4, 7], [-3, 8], [0, 9], [-1, 7], [0, 3], [0, 1]],
    1: [[0, 0], [-1.5, 3.5], [-5, 7.5], [-5, 8], [-4.5, 9], [0, 10], [-2, 9], [-2.5, 8], [-1, 6], [0, 2], [0, 0]],
    2: [[-0.5, 0], [-2.5, 3], [-3, 5.5], [-5.5, 7.5], [-5, 9], [0, 10], [-2.5, 9], [-3, 7.5], [-1, 6], [-1, 4], [-0.5, 2], [-0.5, 0]],
    3: [[-0.5, -2], [-3.5, 1], [-4, 4.5], [-6, 7], [-5.5, 9], [0.5, 10], [-3, 8.5], [-3.5, 7], [-1.5, 5.5], [-1.5, 2], [-0.5, 0], [-0.5, -2]]
  }

  static halfUpperLip0 = [[0, 0], [3, -0.5], [6, 0.75], [8, 1], [6, 2], [3, 1.5], [0, 2]]
  static halfLowerLip0 = [[0, 2], [3, 1.5], [6, 2], [4, 3.5], [0, 4]]

  static halfUpperLip1 = [[0, 0], [3.5, -0.25], [7, 0.75], [10, 1], [8, 1.75], [0, 1.75]]
  static halfLowerLip1 = [[0, 1.25], [3.5, 1.25], [9, 1.75], [4, 2.5], [0, 2.75]]

  static halfUpperLip2 = [[0, 0], [4, 0], [11, 1.5], [0, 1.5]]
  static halfLowerLip2 = [[0, 1.5], [0.5, 1.5], [9, 1.5], [4.5, 2.5], [0.5, 2.5], [0, 2.5]]

  /**
   * Mouths
   */
  static mouths = {
    0: [
      FaceShape.halfLowerLip0.concat(FaceShape.halfLowerLip0.map(mirror).slice().reverse()),
      FaceShape.halfUpperLip0.concat(FaceShape.halfUpperLip0.map(mirror).slice().reverse())
    ],
    1: [
      FaceShape.halfUpperLip1.concat(FaceShape.halfUpperLip1.map(mirror).slice().reverse()),
      FaceShape.halfLowerLip0.concat(FaceShape.halfLowerLip0.map(mirror).slice().reverse()).map(shift(0, -0.25))
    ],
    2: [
      FaceShape.halfUpperLip1.concat(FaceShape.halfUpperLip1.map(mirror).slice().reverse()),
      FaceShape.halfLowerLip1.concat(FaceShape.halfLowerLip1.map(mirror).slice().reverse())
    ],
    3: [
      FaceShape.halfUpperLip2.concat(FaceShape.halfUpperLip2.map(mirror).slice().reverse()),
      FaceShape.halfLowerLip2.concat(FaceShape.halfLowerLip2.map(mirror).slice().reverse())
    ]
  }

  /**
   * Reusable back hair
   */
  static halfHair0 = [
    [0, 0], [-5, -6], [-15, -4], [-20, -1], [-32, 10], [-33, 15], [-37, 30], [-33, 25], [-35, 40], [-40, 55],
    [-35, 50], [-30, 60], [-30, 75], [-25, 70], [-20, 77], [-15, 72], [-10, 79], [-5, 75], [0, 80]
  ]

  static halfHair1 = [
    [0, 0], [-5, -6], [-15, -4], [-20, -1], [-32, 10], [-33, 15], [-37, 30], [-33, 25], [-35, 40], [-40, 55],
    [-35, 50], [-25, 65], [-20, 72], [-15, 76], [-10, 79], [-5, 75], [0, 80]
  ]

  static halfHair2 = [
    [0, 0], [-5, -6], [-15, -4], [-20, -1], [-32, 10], [-33, 15], [-37, 30], [-33, 25], [-35, 40], [-40, 55],
    [-35, 50], [-40, 105], [-25, 108], [-20, 107], [-15, 108], [-10, 109], [-5, 108], [0, 110]
  ]

  /**
   * Hair on the back layer
   */
  static backHair = {
    0: [
      FaceShape.halfHair0.concat(FaceShape.halfHair1.map(mirror).slice().reverse()), // asymmetric
      [[-20, 70], [-20, 80], [-15, 85], [-10, 72]],
      [[-26, 63], [-25, 80], [-20, 75], [-18, 68]]
    ],
    1: [
      FaceShape.halfHair1.concat(FaceShape.halfHair1.map(mirror).slice().reverse())
    ],
    2: [
      FaceShape.halfHair0.concat(FaceShape.halfHair0.map(mirror).slice().reverse())
    ],
    3: [
      FaceShape.halfHair2.concat(FaceShape.halfHair2.map(mirror).slice().reverse())
    ]
  }

  /**
   * Reusable front hair
   */
  static topBang = [[0, 0], [-2, -5], [0, -8], [3, -7], [1, -5]]
  static bigBang = [
    [0, 3], [7, 2], [17, 10], [22, 20], [17, 16],
    [14, 15], [17, 20], [17, 23], [14, 20],
    [8, 17], [5, 24], [-2, 30], [-1, 25],
    [-1, 20], [-6, 25], [-12, 28], [-10, 25],
    [-8, 20], [-18, 26], [-22, 27], [-19, 23],
    [-18, 20], [-26, 22], [-20, 12], [-7, 2], [0, 3]
  ]

  static leftPony = [[-35, 50], [-45, 55], [-48, 70], [-45, 65], [-45, 80], [-40, 70], [-35, 75], [-38, 60]]
  static leftKnot = [[-35, 50], [-39, 49], [-39, 52], [-35, 52]]
  static leftBang0 = [[0, 0], [-5, -6], [-15, -4], [-20, -1], [-32, 10], [-33, 15], [-38, 32], [-33, 25], [0, 3]]
  static leftBang1 = [[0, 3], [-10, 8], [-15, 13], [-15, 23], [-10, 13]]
  static leftBang2 = [[-20, 7], [-30, 35], [-30, 55], [-34, 37], [-40, 40], [-35, 28], [-30, 15]]

  /**
   * Hair on the front layer
   */
  static frontHair = {
    0: [
      FaceShape.topBang,

      FaceShape.leftBang2,
      FaceShape.leftBang2.map(mirror),

      FaceShape.leftBang0,
      FaceShape.leftBang0.map(mirror),

      FaceShape.bigBang.map(mult(1.35, 1.2)).map(shift(2, 0)),

      [[-20, 75], [-20, 85], [-25, 90], [-26, 80], [-20, 75]],
      [[-20, 80], [-20, 90], [-15, 95], [-14, 85], [-20, 80]],
      [[-20, 85], [-20, 95], [-25, 97], [-26, 90], [-20, 85]],
      [[-20, 90], [-20, 95], [-17, 100], [-14, 95], [-20, 90]],

      [
        [-24, 99], [-15, 99], [-14, 105], [-15, 110], [-17, 108], [-18, 112], [-20, 115],
        [-22, 111], [-22, 108], [-24, 112], [-25, 105], [-27, 106], [-24, 99]
      ],
      [[-25, 95], [-15, 95], [-14, 97], [-15, 99], [-24, 99], [-26, 97]]
    ],
    1: [
      FaceShape.topBang,

      FaceShape.leftBang2,
      FaceShape.leftBang2.map(mirror),

      FaceShape.leftBang0,
      FaceShape.leftBang0.map(mirror),

      FaceShape.bigBang,

      FaceShape.leftPony,
      FaceShape.leftPony.map(mirror),

      FaceShape.leftKnot,
      FaceShape.leftKnot.map(mirror)
    ],

    2: [
      FaceShape.topBang,

      FaceShape.leftBang2,
      FaceShape.leftBang2.map(mirror),

      FaceShape.leftBang0,
      FaceShape.leftBang0.map(mirror),

      FaceShape.leftBang1,
      FaceShape.leftBang1.map(mirror),

      [[0, 3], [5, 13], [5, 18], [-2, 23], [0, 18]]
    ],

    3: [
      FaceShape.topBang,

      FaceShape.leftBang2,
      FaceShape.leftBang2.map(mirror),

      FaceShape.leftBang0,
      FaceShape.leftBang0.map(mirror)

      // FaceShape.leftBang1,
      // FaceShape.leftBang1.map(mirror)

      // [[0, 3], [5, 13], [5, 18], [-2, 23], [0, 18]]
    ]

  }

  static bodyShape = [
    [[0, [
      // neck to shoulder
      ...[[0, 0], [9, 0], [10, 15], [11, 18], [13, 19], [17, 20], [35, 24]],

      // shoulder to outer elbow
      ...[[42, 25, 'purple', 2], [48, 28], [51, 33], [54, 46], [60, 64], [65, 95]],

      // outer  elbow to outer wrist
      ...[[65, 105, 'purple', 2], [68, 120], [66, 170]],

      // hand
      ...[[62, 185, 'purple', 2], [56, 192], [51, 189], [53, 180], [54, 177], [53, 179], [51, 177], [57, 170]],

      // inner wrist to inner elbow
      ...[[58, 165, 'purple', 2], [58, 160], [51, 120]],

      // inner elbow to armpit
      ...[[52, 107, 'purple', 2], [51, 100], [47, 90], [42, 74], [39, 58], [36, 50], [35, 45]],

      // armpit to ribs
      ...[[36, 50, 'purple', 2], [37, 62], [37, 70], [35, 78], [32, 84]],

      // ribs to waist
      ...[[29, 90, 'purple', 2], [26, 100], [26, 110], [27, 115], [30, 120], [33, 125]],

      // waist to outer knee
      ...[[36, 133, 'purple', 2], [40, 152], [42, 170], [45, 190], [48, 230], [47, 250], [45, 265], [45, 270]],

      // outer knee to outer ankle
      ...[[44, 276, 'purple', 2], [47, 295], [48, 310], [48, 325], [47, 345], [47, 365], [48, 368], [48, 372]],

      // feet
      ...[[58, 384, 'purple', 2], [58, 388], [53, 390], [36, 390], [31, 389], [31, 384]],

      // inner ankle to inner knee
      ...[[36, 372, 'purple', 2], [35, 370], [35, 368], [36, 365], [33, 345], [30, 335], [26, 320], [24, 300], [23, 278]],

      // inner knee to groin
      ...[[21, 270, 'purple', 2], [20, 267], [13, 240], [3, 195], [1, 173]]
    ]]],
    [[0, [
      // neck to shoulder
      ...[[0, 0], [14, 0], [12, 12], [14, 18], [21, 19], [25, 20], [35, 24], [40, 23]],

      // shoulder to outer elbow
      ...[[45, 24, 'red', 2], [52, 28], [57, 33], [58, 39], [58, 48], [59, 52], [64, 64], [68, 95]],

      // outer  elbow to outer wrist
      ...[[66, 105, 'red', 2], [69, 120], [69, 150], [66, 170]],

      // hand
      ...[[62, 185, 'red', 2], [56, 195], [49, 192], [48, 190], [52, 180], [51, 182], [49, 180], [57, 170]],

      // inner wrist to inner elbow
      ...[[57, 165, 'red', 2], [55, 150], [52, 140], [50, 120]],

      // inner elbow to armpit
      ...[[52, 107, 'red', 2], [50, 100], [45, 90], [40, 74], [38, 58], [36, 50]],

      // armpit to ribs
      ...[[36, 50, 'red', 2], [38, 58], [39, 68], [37, 78], [35, 85]],

      // ribs to waist
      ...[[32, 92, 'red', 2], [31, 102], [30, 108], [30, 115], [31, 120], [33, 125]],

      // waist to outer knee
      ...[[36, 133, 'red', 2], [41, 152], [41, 170], [46, 190], [49, 230], [48, 250], [46, 265], [46, 272]],

      // outer knee to outer ankle
      ...[[45, 278, 'red', 2], [49, 295], [51, 310], [50, 325], [47, 350], [47, 370], [48, 373], [48, 377]],

      // feet
      ...[[58, 389, 'red', 2], [58, 393], [53, 395], [36, 395], [31, 394], [31, 389]],

      // inner ankle to inner knee
      ...[[36, 377, 'red', 2], [35, 370], [35, 373], [36, 365], [32, 345], [29, 335], [25, 320], [23, 300], [23, 280]],

      // inner knee to groin
      ...[[21, 274, 'red', 2], [20, 267], [13, 240], [3, 195], [1, 173]]
    ]]]
  ]

  static underwearTop = [
    [42, [[20, 0], [21, -22], [25, -21], [25, 0]]],
    [40, [[25, 0], [32, 10], [35, 20], [36, 26], [37, 28], [38, 28], [36, 37], [32, 45], [29, 60], [30, 70]]]
  ]

  static underwearDress = [
    [42, [[20, 0], [21, -22], [25, -21], [25, 0]]],
    [110, [
      [28, 0, 'fuchsia', 2], [29, 5], [34, 15], [36, 20], [40, 35],
      [42, 45, 'fuchsia', 2], [44, 59], [46, 80], [48, 87], [50, 97], [51, 100],
      [42, 102, 'fuchsia', 2], [36, 105], [26, 108], [10, 110]
    ]],
    [40, [
      [25, -2, 'fuchsia', 2], [32, 10], [35, 20], [36, 26], [37, 28], [37, 28], [35, 38], [32, 45],
      [29, 54, 'fuchsia', 2], [27, 62], [27, 72], [29, 75]
    ]]
  ]

  static underwearBottom = [
    [150, [[5, 0], [20, -3], [38, -10], [39, -6], [15, 3], [13, 10], [3, 25]]],
    [148, [[4, 0], [15, -1], [20, 55], [0, 57]]]
  ]

  static swimSuit = [
    [70, [
      ...[[1, 0], [8, -15], [15, -25], [19, -30]],
      ...[[18, -40], [13, -52], [15, -52], [20, -40], [25, -30]],
      ...[[29, -25], [34, -15], [37, -2], [35, 7], [32, 13], [30, 22]],
      ...[[27, 32], [27, 38], [28, 45], [31, 50], [34, 55]],
      ...[[36, 60], [28, 70], [16, 80], [9, 90], [5, 100], [4, 102], [2, 104]]
    ]],
    [70, [
      ...[[1, 0], [1, 2], [6, 7], [10, 9], [25, 11], [32, 13]],
      ...[[32, 14], [25, 12], [10, 10], [6, 8], [1, 3]]
    ]]
  ]
}
